export default __webpack_public_path__ + "static/media/img2.0ff9d8c3.svg";